import React from 'react';
import { Zap, Wallet, ShieldCheck, Truck, ArrowRight } from 'lucide-react';

const ChinaFlag = ({ className }) => (
  <svg viewBox="0 0 30 20" className={className} aria-hidden="true">
    <rect width="30" height="20" fill="#DE2910" rx="1.5" />
    <path d="M5 3 L6.18 6.62 L2.1 4.38 L7.9 4.38 L3.82 6.62 Z" fill="#FFDE00" transform="scale(1.15) translate(-0.5,-0.2)" />
    <circle cx="10.5" cy="2.2" r="0.9" fill="#FFDE00" />
    <circle cx="12" cy="4.2" r="0.9" fill="#FFDE00" />
    <circle cx="12" cy="6.8" r="0.9" fill="#FFDE00" />
    <circle cx="10.5" cy="8.8" r="0.9" fill="#FFDE00" />
  </svg>
);

const FEATURES = [
  { icon: Zap, title: 'Оплата за 24 години', text: 'Викупимо ваш товар або оплатимо інвойс постачальнику протягом доби.' },
  { icon: Wallet, title: 'Будь-яка валюта та спосіб', text: 'Ви оплачуєте нам — миттєво переказуємо кошти постачальнику в юанях (Alipay, WeChat, UnionPay) або через SWIFT.' },
  { icon: ShieldCheck, title: 'Безпека', text: '100% фінансова гарантія на кожну транзакцію.' },
  { icon: Truck, title: 'Доставка до дверей', text: "Власний кур'єрський сервіс по Києву та Київській області." },
];

export const ChinaPaymentBlock = ({ onCta, compact = false }) => (
  <section className={compact ? '' : 'py-14 px-4'} data-testid="china-payment-block">
    <div className={compact ? '' : 'max-w-6xl mx-auto'}>
      <div className="relative overflow-hidden rounded-3xl bg-[#0a1224] border-2 border-yellow-400/60 shadow-[0_0_50px_-10px_rgba(250,204,21,0.45)]">
        {/* neon frame accents */}
        <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-yellow-400 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-red-500 to-transparent" />
        {/* big translucent China flag in the corner */}
        <ChinaFlag className="absolute -right-10 -top-10 w-72 md:w-96 opacity-[0.13] rotate-12 pointer-events-none" />
        <div className="absolute -left-16 -bottom-16 w-56 h-56 bg-red-600/20 rounded-full pointer-events-none" />

        <div className="relative p-6 md:p-10">
          <div className="flex items-start gap-4 mb-3 flex-wrap">
            <ChinaFlag className="w-14 md:w-16 rounded shadow-[0_0_20px_rgba(222,41,16,0.6)] shrink-0" />
            <div className="flex-1 min-w-[260px]">
              <h2 className="text-white font-black text-xl md:text-3xl leading-tight uppercase tracking-wide">
                Миттєва оплата постачальникам у Китай — <span className="text-yellow-400">100% гарантія</span>
              </h2>
              <p className="text-slate-300 mt-2 text-sm md:text-base">
                Ми — найшвидший сервіс в Україні для вашого бізнесу. Більше ніяких затримок та очікувань!
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 mt-6">
            {FEATURES.map(f => (
              <div key={f.title} className="flex items-start gap-3 rounded-2xl bg-slate-900/60 border border-yellow-400/20 p-4 hover:border-yellow-400/50 transition-colors">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-yellow-400 to-red-500 flex items-center justify-center shrink-0 shadow-[0_0_16px_rgba(250,204,21,0.4)]">
                  <f.icon className="w-5 h-5 text-[#0a1224]" />
                </div>
                <div>
                  <p className="text-white font-bold text-sm md:text-base">{f.title}</p>
                  <p className="text-slate-400 text-xs md:text-sm mt-0.5">{f.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-7 flex justify-center">
            <button
              onClick={onCta}
              className="group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-yellow-400 to-red-500 text-[#0a1224] font-black text-sm md:text-base uppercase tracking-wide shadow-[0_0_30px_rgba(250,204,21,0.5)] hover:shadow-[0_0_45px_rgba(250,204,21,0.8)] hover:scale-[1.03] transition-all"
              data-testid="china-payment-cta"
            >
              Замовити оплату / Консультація
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
);
